module.exports = __webpack_public_path__ + "media/react/assets/EmpNotUpdatedGoal-f85d19f522c7fe63b935ab94b5668866.svg";